import { Box } from "theme-ui";

import { useNavHeight } from "@theme/utils";

import type { FC, ReactNode } from "react";
import type { BoxProps } from "theme-ui";

export interface StrapiSectionWrapperProps extends Omit<BoxProps, "as"> {
  anchorId?: string | null;
  "data-strapi-module": string;
  "data-strapi-section": string;
  children: ReactNode;
}

/**
 * Section wrapper for Strapi modules. Renders as a `<section>` element.
 *
 * Modules can optionally carry an `anchorId` (set in Strapi). When present,
 * the wrapper renders it as the element `id` and applies `scrollMarginTop`
 * to compensate for the sticky nav.
 */
export const StrapiSectionWrapper: FC<StrapiSectionWrapperProps> = ({
  anchorId,
  id,
  sx,
  children,
  ...rest
}) => {
  const { currentNavHeight } = useNavHeight();

  return (
    <Box
      as="section"
      {...rest}
      id={anchorId ?? id ?? undefined}
      sx={{
        ...(anchorId ? { scrollMarginTop: currentNavHeight } : {}),
        ...(sx as object),
      }}
    >
      {children}
    </Box>
  );
};
